import { render, staticRenderFns } from "./moreOUSP.vue?vue&type=template&id=58bac3e6&lang=pug&"
import script from "./moreOUSP.vue?vue&type=script&lang=js&"
export * from "./moreOUSP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports